import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
  import RichText from '@/ui/components/richText/RichText.vue';
  import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionTitle',
  props: {
    question: {
      type: Object as () => LegacyItem,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { isTranslationEnabled } = useInspectionReport();

  const title = computed(() => {
    if (props.question.params.rte_title) {
      return isTranslationEnabled && props.question.html_title_translated
        ? props.question.html_title_translated
        : (props.question.html_title ?? '');
    }

    return isTranslationEnabled && props.question.title_translated
      ? props.question.title_translated
      : (props.question.title ?? '');
  });

return { __sfc: true,props, isTranslationEnabled, title, RichText }
}

})